import useConnectionsPage from 'new/components/flows/controller/useConnectionsPage';
import useLLMProcessor from 'new/elements/flows/ModalConfigureLLM/useLLMProcessor';
import { SelectConnection } from 'new/elements/flows/SelectConnection';
import { FCFormPageType, useForm } from 'new/elements/Form/useForm';
import React from 'react';
import { useSelector } from 'react-redux';

interface SelectConnectionPageProps {}

export const SelectConnectionStep: FCFormPageType<SelectConnectionPageProps> = (
  props: SelectConnectionPageProps,
) => {
  const { nextPage } = useForm();
  const { selectedConnection, onSelectConnection } = useLLMProcessor();
  const llmsAllowed = useSelector((state: any) => state.paging.llmsAllowed);
  useConnectionsPage(selectedConnection);

  const onConnectionSelected = (selectedConnection) => {
    onSelectConnection(selectedConnection);
    nextPage(null, true);
  };

  return (
    <SelectConnection
      overrideConnections={llmsAllowed}
      connectionType="SINK"
      selectedConnection={selectedConnection}
      onConnectionSelected={onConnectionSelected}
    />
  );
};

SelectConnectionStep.formConfig = {
  title: 'Select',
};
